import './footer.css';

import * as React from 'react';

const Footer = props => (
  <footer className="footer page-content">
    <div className="footer-grid">
      <div>
        <h2>Betting Bookshop</h2>
        <p>Betting guides, staking plans, systems and software for football, horse racing, greyhounds, tennis and cricket.</p>
      </div>
      <div>
        <h2>Get started</h2>
        <ol>
          <li>Register with your name and email address.</li>
          <li>Open the link we email you to activate your account.</li>
          <li>Log in to see your subscribed products.</li>
        </ol>
      </div>
      <div>
        <h2>Account rules and help</h2>
        <p>Your account is for you alone. If we find a shared account, we block it immediately.</p>
        <p>
          Questions? Email Michael at <a href="mailto:racingsoftware@gmail.com">racingsoftware@gmail.com</a>.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
